import { render, staticRenderFns } from "./SettingsPage.vue?vue&type=template&id=57f7154e&scoped=true&"
import script from "./SettingsPage.vue?vue&type=script&lang=ts&"
export * from "./SettingsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f7154e",
  null
  
)

export default component.exports